import { AxiosInstance } from 'axios'

export function getCoursesListResponse(axios: AxiosInstance, params: Object) {
  return axios({
    url: '/v1/hps/courses',
    method: 'get',
    params,
  })
}
